import { Button, Tooltip } from '@mui/material';
import React from 'react';

interface FighterPickerButtonProps {
  fighterName: string;
  isTitleFight: boolean;
  tooltipContent: React.ReactNode;
  onClick: () => void;
  isEnabled: boolean;
  isUpcoming: boolean;
}

const FighterPickerButton: React.FC<FighterPickerButtonProps> = ({
  fighterName,
  isTitleFight,
  tooltipContent,
  onClick,
  isEnabled,
  isUpcoming,
}) => {
  return (
    <Tooltip title={tooltipContent} arrow>
      <Button
        variant="contained"
        sx={{
          fontFamily: 'Bebas Neue',
          width: '100%',
          fontSize: { xs: '1rem', sm: 'clamp(0.6rem, 1vw, 1.3rem)' },
          backgroundColor: isTitleFight ? '#8B6508' : '#1A1A1A',
          '&:hover': {
            backgroundColor: isEnabled && isUpcoming ? '#8b0000' : '#a9a9a9',
          },
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
        onClick={onClick}
      >
        {isTitleFight && <span style={{ marginRight: '4px' }}>👑</span>}
        {fighterName}
      </Button>
    </Tooltip>
  );
};

export default FighterPickerButton;
